<div class="confirm-dialog-wrapper">
    <h1 id="confirmation-header">
        <mat-icon class="material-icons" *ngIf="!isPIIShieldApplied">gpp_maybe</mat-icon>
        <mat-icon *ngIf="isPIIShieldApplied" class="pii-free">verified_user</mat-icon>
        {{title}}?
    </h1>

    <div class="mb-20">
        <ngc-piishield-attributes-list *ngIf="piiShieldAttributesDataMaskingListCount > 0"
                                       [headerText]="'Privacy Shield will ' + (!isPIIShieldApplied ? 'disable ' : 'enable') +  ' data masking for ' + piiShieldAttributesDataMaskingListCount + (piiShieldAttributesDataMaskingListCount > 1 ? ' attributes:' : ' attribute:')"
                                       [showErrorIcon]="false"
                                       [attributesList]="piiShieldAttributesDataMaskingList"
                                       [attributeStyleClass]="isPIIShieldApplied ? 'mb-REMOVE': 'mb-ADD'"
        >

        </ngc-piishield-attributes-list>
    </div>

    <div class="mb-20">
        <ngc-piishield-attributes-list *ngIf="piiShieldAttributesAbilityListCount > 0"
                                       class="mb-20"
                                       [headerText]="'Privacy Shield will ' + (isPIIShieldApplied ? 'disable ' : 'enable ') + piiShieldAttributesAbilityListCount + ' sensitive data ' + (piiShieldAttributesAbilityListCount > 1 ? 'attributes:' : 'attribute:')"
                                       [showErrorIcon]="false"
                                       [attributesList]="piiShieldAttributesAbilityList"
                                       [attributeStyleClass]="isPIIShieldApplied ? 'mb-REMOVE': 'mb-ADD'"
        >

        </ngc-piishield-attributes-list>
    </div>

    <div class="mb-20">
        <ngc-piishield-attributes-list *ngIf="PIIShieldRequiredAttributesAbilityList?.length > 0"
                                       class="mb-20"
                                       [headerText]=" isPIIShieldApplied && (PIIShieldRequiredAttributesAbilityList?.length > 0) && piiShieldCouldBeApplied
                                                      ? 'Some sensitive data attributes are required and are not disabled.'
                                                      : (!piiShieldCouldBeApplied && (PIIShieldRequiredAttributesAbilityList?.length > 0)
                                                          ? 'All sensitive data attributes are required and are not disabled.'
                                                          : '')"
                                       [showErrorIcon]="true"
                                       [attributesList]="PIIShieldRequiredAttributesAbilityList"
                                       [attributeStyleClass]="'mb-no-changes'"
        >

        </ngc-piishield-attributes-list>
    </div>

    <a class="font-weight-500 mb-20" href="https://dev.gg4l.com/docs/how-to-get-started-with-pii-shield" target="_blank" rel="noopener">Learn more about Privacy Shield</a>

    <div class="button-row">
        <button mat-button class="discard-btn mr-8" (click)="onClose('cancel')">Cancel</button>
        <button *ngIf="(piiShieldAttributesDataMaskingListCount > 0) && isPIIShieldApplied"
                mat-button
                class="discard-btn mr-8"
                (click)="onClose('apply masking only')"
        >
            Apply Masking Only
        </button>
        <button mat-raised-button color="primary" (click)="onClose('ok')">{{isPIIShieldApplied ? 'Apply' : 'Revert changes' }}</button>
    </div>
</div>
